export const errorCodeMap = {
    "No Answer": 301,
    "Third Party API Error": 302,
    "Internal Server Error": 303,
    "General ML Codebase Error": 304,
    "Translation API Error": 305,
    "Invalid OpenAI model output": 500,
    "Model is not responding": 501
}

export const modelNotRespondingConstant = {
    "en": "I am experiencing a problem in generating a response. Please try again or ask a different question.",
    "hi": "मुझे जवाब तैयार करने में समस्या आ रही है। कृपया फिर से प्रयास करें या कोई और सवाल पूछें।",
    "or": "ମୁଁ ପ୍ରତିକ୍ରିୟା ସୃଷ୍ଟି କରିବାରେ ସମସ୍ୟା ଅନୁଭବ କରୁଛି। ଦୟାକରି ପୁନର୍ବାର ଚେଷ୍ଟା କରନ୍ତୁ କିମ୍ବା ଅନ୍ୟ ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ।",
}